/** User-visible copy after email OTP start (overlay LoginForm + marketing chrome). */
export function emailOtpSentMessage(email: string): string {
  return (
    'We emailed a 6-digit code to ' +
    email +
    '. Enter it below (check spam if needed — mail is sent from our Workspace address). If you requested more than one code, use only the newest email.'
  );
}
